jQuery(document).ready(function NavModal($) {
	var getContact = function() {
		var $contact = $('<div class="modal-menu__contact"></div>');
		var $footerAddress = $('.footer__address');
		var $address = $('<div class="modal-menu__address"></div>');
		var $footerContactBlocks = $('.contact-blocks .contact-block');
		var $contactBlocks = $('<div class="modal-menu__contact-blocks contact-blocks row"></div>');
		var $footerContactBlock;
		
		var last = $footerContactBlocks.length-1;
		var $col;
		
		for(var i = 0, s = $footerContactBlocks.length; i < s; ++i) {
			if(last === i){
				$col = $('<div class="col-xs-12 col-md-12"></div>');
			} else {
				$col = $('<div class="col-xs-6 col-md-6"></div>');
			}
			$col.append($($footerContactBlocks[i]).clone());
			$contactBlocks.append($col);
		}
		
		$contact.append($contactBlocks);
		$address.append($footerAddress.html());
//		$contact.append($address);
		return $contact;
	};
	
	var getMenu = function() {
		var $out = $('<ul class="modal-menu__nav modal-menu__nav--default"></ul>');
		var $lis = $('.nav-top__menu__content--default li');
		var $li;
		var $item;
		
		for(var i = 0, s = $lis.length; i < s; ++i) {
			$item = $('<li class="modal-menu__nav-item"></li>');
			$li = $($lis[i]);
			$item.append($li.find('a').clone());
			$out.append($item);
		}
		
		return $out;
	};
	
	var getInvestmentMenu = function() {
		var $out = $('<ul class="modal-menu__nav modal-menu__nav--investment"></ul>');
		var $lis = $('.top-header__navigation__menu__container li');
		var $li;
		var $item;
		
		for(var i = 0, s = $lis.length; i < s; ++i) {
			$item = $('<li class="modal-menu__nav-item"></li>');
			$li = $($lis[i]);
			$item.append($li.find('a').clone());
			$out.append($item);
		}
		
		return $out;
	};
	
	var getBranding = function() {
		var $out = $('<div class="modal-menu-branding"></div>');
		$out.append($('.nav-top__branding a').clone());
		return $out;
	};
	
	
	this.show = function() {
		var $modal
		var $content = $('<div class="modal-menu"></div>');
		
		
		$content.append(getBranding())
		$content.append(getMenu());
		$content.append(getInvestmentMenu());
		$content.append(getContact());
		
		$modal = modalHelper.prepareTemplate($content);
		
		navHelper.initLinks($modal, function() {
			this.hide();
		}.bind(this));
		
		modalHelper.open($modal);
		window.history.pushState('', '', '#menu');
		$modal.on('modal.close', function() {
			window.history.pushState('', '', '#');
		});
	};
	
	this.hide = function() {
		modalHelper.closeAll();
	};
	
	$(document).ready(function(){
		$('.nav-top__menu__toggle').click(function() {
			this.show();
			return false;
		}.bind(this));
		
		if(window.location.hash === '#menu') {
			this.show();
		}
	}.bind(this));
});
